import type { ThemeIconProps as MantineThemeIconProps } from '@mantine/core';
import { ThemeIcon as MantineThemeIcon } from '@mantine/core';

import type { LockedProps } from '../types';

// Plain `Omit`, not `PolymorphicComponentProps`: no call site renders this as another element, and
// the polymorphic wrapper's `any` component type silently re-admitted every locked prop.
// `MantineThemeIconProps` already extends `ElementProps<'div'>`, so `children` and the div's own
// props come through.
type ThemeIconProps = Omit<MantineThemeIconProps, LockedProps>;

export const ThemeIcon = (props: ThemeIconProps) => {
  return <MantineThemeIcon {...props} />;
};
